module.exports = __webpack_public_path__ + "img/documents-acpt.2717c8a4.svg";